var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CChartDoughnut',{attrs:{"datasets":_vm.dados,"labels":_vm.titulos,"options":_vm.options}})
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/GraficoDoughnut.vue?vue&type=template&id=418704ec&
// module id = null
// module chunks = 